import React from "react"
import { DateBox, Template } from "devextreme-react";
import { renderDateIcon } from "../../commonFunctions/commonFunctions";


function CustomDateBox(props){

    return(
    <DateBox
    {...props}
    showDropDownButton
    dropDownButtonTemplate="calendarIcon">
     <Template
         name="calendarIcon"
         render={renderDateIcon}
     />
    </DateBox>
    )
}

export default CustomDateBox